const GUIDE_LINK_CARDS = [
  {
    id: 'getting-married',
    title: 'Complete Guide to Getting Married in Gibraltar',
    subtitle: 'Overview & Requirements',
    href: '/getting-married-in-gibraltar',
  },
  {
    id: 'how-to-get-married',
    title: 'Step-by-Step Guide to Getting Married in Gibraltar',
    subtitle: 'Process & Timeline',
    href: '/how-to-get-married-in-gibraltar',
  },
  {
    id: 'cost-getting-married',
    title: 'Cost of Getting Married in Gibraltar',
    subtitle: 'Budget & Pricing',
    href: '/cost-of-getting-married-in-gibraltar',
  },
];

export const GuideLinksCardsBlock = ({
  currentPath,
  testIdPrefix = 'guide-links-cards',
}) => {
  return (
    <section
      className="space-y-4 rounded-xl border border-[#D4AF37]/35 bg-white p-4 md:p-6 shadow-[0_12px_30px_rgba(28,25,23,0.04)]"
      data-testid={`${testIdPrefix}-guide-links-section`}
    >
      <p
        className="text-sm md:text-base leading-relaxed text-stone-700"
        data-testid={`${testIdPrefix}-guide-links-intro`}
      >
        Planning your wedding in Gibraltar? Explore our complete guides below to understand the process, costs, and requirements.
      </p>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3" data-testid={`${testIdPrefix}-guide-links-grid`}>
        {GUIDE_LINK_CARDS.map((card) => {
          const isActive = card.href === currentPath;
          return (
            <a
              key={card.id}
              href={card.href}
              className={`group block rounded-xl border p-4 transition ${
                isActive
                  ? 'border-[#D4AF37] bg-[#4A001A] text-white ring-2 ring-[#D4AF37]/45'
                  : 'border-[#5C0120]/30 bg-[#F9F4F0] text-[#2f1f1a] hover:border-[#5C0120] hover:bg-[#fff7ef]'
              }`}
              aria-current={isActive ? 'page' : undefined}
              data-testid={`${testIdPrefix}-guide-link-card-${card.id}`}
            >
              <p
                className={`text-sm font-semibold leading-snug ${
                  isActive ? 'text-white' : 'text-[#5C0120]'
                }`}
                data-testid={`${testIdPrefix}-guide-link-card-title-${card.id}`}
              >
                {card.title}
              </p>
              <p
                className={`mt-1 text-xs ${
                  isActive ? 'text-[#f8e8b5]' : 'text-stone-600 group-hover:text-[#5C0120]'
                }`}
                data-testid={`${testIdPrefix}-guide-link-card-subtitle-${card.id}`}
              >
                {card.subtitle}
              </p>
            </a>
          );
        })}
      </div>
    </section>
  );
};
